import React from 'react';
import { Slider, Typography } from 'antd';

const { Text } = Typography;

export function npsEmoji(score: number): string {
  if (score <= 2) return '😡';
  if (score <= 4) return '😞';
  if (score <= 6) return '😕';
  if (score <= 8) return '😐';
  if (score === 9) return '🙂';
  return '😄';
}

export function npsLabel(score: number): string {
  if (score >= 9) return 'Promoter';
  if (score >= 7) return 'Passive';
  return 'Detractor';
}

export const NpsScorePicker: React.FC<{
  value: number;
  onChange: (score: number) => void;
}> = ({ value, onChange }) => {
  const score = Math.min(10, Math.max(0, Number(value) || 0));

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 8,
          gap: 12,
        }}
      >
        <Text type="secondary" style={{ fontSize: 28, lineHeight: 1 }} title="Unlikely to recommend">
          😢
        </Text>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: 48, lineHeight: 1.1 }} aria-hidden>
            {npsEmoji(score)}
          </div>
          <Text strong style={{ display: 'block', marginTop: 4 }}>
            {score} / 10 — {npsLabel(score)}
          </Text>
        </div>
        <Text type="secondary" style={{ fontSize: 28, lineHeight: 1 }} title="Very likely to recommend">
          😊
        </Text>
      </div>
      <Slider
        min={0}
        max={10}
        step={1}
        value={score}
        onChange={onChange}
        marks={{
          0: '0',
          5: '5',
          10: '10',
        }}
        tooltip={{ formatter: (v) => `${v} ${npsEmoji(Number(v))}` }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            style={{
              border: score === n ? '2px solid #1677ff' : '1px solid #d9d9d9',
              borderRadius: 6,
              background: score === n ? '#e6f4ff' : '#fff',
              cursor: 'pointer',
              padding: '2px 4px',
              fontSize: 11,
              minWidth: 22,
            }}
          >
            {n}
          </button>
        ))}
      </div>
    </div>
  );
};
